import {
    AfterViewInit,
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    ElementRef,
    OnDestroy,
    OnInit,
    Renderer,
    ViewChild
} from '@angular/core';
import {AuthService} from '../core/security/auth.service';
import {Router} from '@angular/router';
import {
    ConfigService,
    MenuOrientation
} from '../personal-config/config.service';
import {ConversationService} from '../fiscalia/service/chat/conversation.service';
import {PageStateService} from '../core/service/page-state.service';

declare var jQuery: any;

@Component({
    selector: 'app-main',
    templateUrl: 'home.component.html',
    styleUrls: ['home.component.scss']
    // changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HomeComponent implements AfterViewInit, OnInit, OnDestroy {
    layoutCompact = true;

    layoutMode: MenuOrientation = MenuOrientation.STATIC;

    darkMenu = false;

    profileMode = 'inline';

    rotateMenuButton: boolean;

    topbarMenuActive: boolean;

    overlayMenuActive: boolean;

    staticMenuDesktopInactive: boolean;

    staticMenuMobileActive: boolean;

    layoutContainer: HTMLDivElement;

    layoutMenuScroller: HTMLDivElement;

    modal: HTMLDivElement;

    menuClick: boolean;

    topbarItemClick: boolean;

    activeTopbarItem: any;

    documentClickListener: Function;

    resetMenu: boolean;

    @ViewChild('layoutContainer') layourContainerViewChild: ElementRef;

    @ViewChild('layoutMenuScroller') layoutMenuScrollerViewChild: ElementRef;

    private subcriptions = [];

    constructor(
        public renderer: Renderer,
        private authService: AuthService,
        private router: Router,
        private configService: ConfigService,
        private conversationService: ConversationService,
        // private cd: ChangeDetectorRef,
        private pageState: PageStateService
    ) {
    }

    ngOnInit() {
        this.pageState.loadRouting();

        if (this.authService.isLoggedIn()) {
            this.subcriptions.push(
                this.authService.user.subscribe(u => {
                    this.conversationService.setUserAndConversations(u);
                    // this.cd.markForCheck();
                })
            );
            this.authService.setUserIn();
        } else {
            this.router.navigate(['login']);
        }
        this.subcriptions.push(
            this.configService.configChanges.subscribe(config => {
                this.layoutCompact = config.layoutCompact;
                this.layoutMode = config.layoutMode;
                this.profileMode = config.profileMode;
                // this.cd.markForCheck();
            })
        );
    }

    ngAfterViewInit() {
        this.layoutContainer = <HTMLDivElement>(
            this.layourContainerViewChild.nativeElement
        );
        this.layoutMenuScroller = <HTMLDivElement>(
            this.layoutMenuScrollerViewChild.nativeElement
        );

        // hides the horizontal submenus or top menu if outside is clicked
        this.documentClickListener = this.renderer.listenGlobal(
            'body',
            'click',
            event => {
                if (!this.topbarItemClick) {
                    this.activeTopbarItem = null;
                    this.topbarMenuActive = false;
                }

                if (!this.menuClick && this.isHorizontal()) {
                    this.resetMenu = true;
                }

                this.topbarItemClick = false;
                this.menuClick = false;

                // this.cd.markForCheck()
            }
        );

        setTimeout(() => {
            jQuery(this.layoutMenuScroller).nanoScroller({flash: true});
        }, 10);
    }

    onMenuButtonClick(event) {
        this.rotateMenuButton = !this.rotateMenuButton;
        this.topbarMenuActive = false;

        if (this.layoutMode === MenuOrientation.OVERLAY) {
            this.overlayMenuActive = !this.overlayMenuActive;

            if (this.overlayMenuActive) this.enableModal();
            else this.disableModal();
        } else {
            if (this.isDesktop()) {
                this.staticMenuDesktopInactive = !this.staticMenuDesktopInactive;
            } else {
                if (this.staticMenuMobileActive) {
                    this.staticMenuMobileActive = false;
                    this.disableModal();
                } else {
                    this.staticMenuMobileActive = true;
                    this.enableModal();
                }
            }
        }

        event.preventDefault();
        // this.cd.markForCheck();
    }

    onMenuClick($event) {
        this.menuClick = true;

        if (!this.isHorizontal()) {
            setTimeout(() => {
                jQuery(this.layoutMenuScroller).nanoScroller();
            }, 500);
        }
        // this.cd.markForCheck();
    }

    onTopbarMenuButtonClick(event) {
        this.topbarItemClick = true;
        this.topbarMenuActive = !this.topbarMenuActive;

        if (this.overlayMenuActive || this.staticMenuMobileActive) {
            this.rotateMenuButton = false;
            this.overlayMenuActive = false;
            this.staticMenuMobileActive = false;
            this.disableModal();
        }
        // this.cd.markForCheck();
    }

    onTopbarItemClick(event, item) {
        this.topbarItemClick = true;

        if (this.activeTopbarItem === item) this.activeTopbarItem = null;
        else this.activeTopbarItem = item;

        event.preventDefault();
        // this.cd.markForCheck();
    }

    enableModal() {
        this.modal = document.createElement('div');
        this.modal.className = 'layout-mask';
        this.layoutContainer.appendChild(this.modal);
        // this.cd.markForCheck();
    }

    disableModal() {
        if (this.modal) {
            this.layoutContainer.removeChild(this.modal);
        }
        // this.cd.markForCheck();
    }

    isTablet() {
        const width = window.innerWidth;
        return width <= 1024 && width > 640;
    }

    isDesktop() {
        return window.innerWidth > 1024;
    }

    isMobile() {
        return window.innerWidth <= 640;
    }

    isOverlay() {
        return this.layoutMode === MenuOrientation.OVERLAY;
    }

    isHorizontal() {
        return this.layoutMode === MenuOrientation.HORIZONTAL;
    }

    changeToStaticMenu() {
        this.layoutMode = MenuOrientation.STATIC;
        // this.cd.markForCheck();
    }

    changeToOverlayMenu() {
        this.layoutMode = MenuOrientation.OVERLAY;
        // this.cd.markForCheck();
    }

    changeToHorizontalMenu() {
        this.layoutMode = MenuOrientation.HORIZONTAL;
        // this.cd.markForCheck();
    }

    ngOnDestroy() {
        this.subcriptions.forEach(s => s.unsubscribe());

        this.disableModal();

        if (this.documentClickListener) {
            this.documentClickListener();
        }

        jQuery(this.layoutMenuScroller).nanoScroller({flash: true});
    }
}



// WEBPACK FOOTER //
// ./src/app/home/home.component.ts